import styled from 'styled-components'
import { BP } from 'resources/constants'

export const ReviewListWrapper = styled.div`
  margin: 10px auto 0;

  @media (min-width: ${BP.sm.min}) {
    margin-top: 15px;
  }

  @media (min-width: ${BP.md.min}) {
    max-width: 65%;
    margin-top: 20px;
  }

  > div + div {
    margin-top: 10px;

    @media (min-width: ${BP.sm.min}) {
      margin-top: 15px;
    }

    @media (min-width: ${BP.md.min}) {
      margin-top: 20px;
    }
  }
`

export const ReviewItem = styled.div`
  padding: 20px;
  background: ${props => props.theme.palette.primary.alphaLight};

  @media (min-width: ${BP.md.min}) {
    padding: 25px;
  }

  .review__overview {
    text-align: center;

    > div {
      justify-content: center;
    }

    h4 {
      margin: 10px 0 0;
      font-size: 17px;

      @media (min-width: ${BP.sm.min}) {
        font-size: 20px;
      }
    }

    .react-rater-star {
      width: 16px;
      height: 16px;
      background-size: 16px;

      @media (min-width: ${BP.sm.min}) {
        width: 20px;
        height: 20px;
        background-size: 20px;
      }
    }
  }

  .review__content {
    margin-top: 15px;
    text-align: center;

    @media (min-width: ${BP.md.min}) {
      text-align: left;
    }

    p {
      margin: 0;
      color: ${props => props.theme.palette.general.textColor};
      line-height: 1.5;
      font-size: 15px;

      &.review__name {
        font-weight: 600;
        color: ${props => props.theme.palette.general.headerColor};

        @media (min-width: ${BP.sm.min}) {
          font-size: 17px;
        }
      }

      &.review__detail {
        margin-top: 10px;
      }
    }
  }
`
